import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { Box, Divider, Grid, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import metamask from "./images/wallet/metamask.png";
import trustwallet from "./images/wallet/trustwallet.png";
import walletConnect from "./images/wallet/walletconnect.png";
import MathWallet from "./images/wallet/mathwallet.png";
import Coin98 from "./images/wallet/coin98.png";
import binance from "./images/wallet/binance.png";
import { useWeb3React } from "@web3-react/core";
import theme from "./theme";
import { bsc, injected, walletconnect } from "./connector";
// import useAuth, { connectorLocalStorageKey } from "../../hooks/useAuth";

const useStyles = makeStyles(() => ({
  modalContainer: {
    backgroundColor: "#000A19",
    // border: `2px solid #1E293B`,
    paddingLeft: "18px",
    paddingRight: "18px",
  },
  Wbox: {
    ...theme.modalColors.box,
    textAlign: "center",
    cursor: "pointer",
    padding: "1.4rem 2rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem 0rem",
    },
  },
  walletImages: {
    width: "33%",
    height: "2.1rem",
    [theme.breakpoints.down("sm")]: {
      width: "16%",
      height: "1.3rem",
    },
  },
  walletText: {
    color: theme.modalColors.textColor,
    fontFamily: theme.modalColors.font,
    paddingTop: ".2rem",
    fontSize: "12px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
}));
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        {...props}
        style={{
          borderRadius: "0px",
          maxWidth: "25rem",
        }}
      />
    </Draggable>
  );
}
export default function WalletConnectModal({ walletOpen, setWalletOpen }) {
  const classes = useStyles();
  // const { login, logout } = useAuth();

  const { activate } = useWeb3React();
  const handleClose = () => {
    setWalletOpen(false);
  };
  const matches = useMediaQuery("(max-width:750px)");
  // const matches = useMediaQuery("(max-width:600px)");
  var c;
  matches && window.web3 ? (c = injected) : (c = walletconnect);
  const wData = [
    { name: "Metamask", img: metamask, connectorId: injected },
    { name: "TrustWallet", img: trustwallet, connectorId: c },
    { name: "WalletConnect", img: walletConnect, connectorId: c },
    { name: "MathWallet", img: MathWallet, connectorId: c },
    { name: "Coin98", img: Coin98, connectorId: c },
    { name: "Binance Chain", img: binance, connectorId: bsc },
  ];

  return (
    <div>
      <Dialog
        open={walletOpen}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <Box className="details-box">
          <span className="span"></span>
          <span className="span"></span>
          <span className="span"></span>
          <span className="span"></span>
          <Box className={classes.modalContainer}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <DialogTitle
                style={{
                  color: "#ffffff",
                  // fontFamily: theme.modalColors.font,
                }}
                id="draggable-dialog-title"
              >
                <Box fontSize={{ xs: "20px", sm: "25px" }}>
                  Connect to a wallet
                </Box>
              </DialogTitle>
              <Box>
                <DialogActions>
                  <CloseIcon
                    fontSize={matches ? "medium" : "large"}
                    onClick={handleClose}
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                </DialogActions>
              </Box>
            </Box>
            <Divider
              style={{
                width: "100%",
                backgroundColor: "#F1F5F91F",
                height: "1px",
                marginBottom: "15px",
              }}
            />
            <DialogContent>
              <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                {wData.map(({ connectorId, name, img }, i) => (
                  <Grid key={i} item xs={matches ? 6 : 12} lg={6} md={6} sm={6}>
                    <Box
                      className={classes.Wbox}
                      onClick={() => {
                        activate(connectorId);
                        handleClose();
                        localStorage.setItem("wallet", "meta");
                      }}
                    >
                      <Box>
                        <img src={img} alt="metamask" />
                      </Box>
                      <Box className={classes.walletText}>{name}</Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </DialogContent>
          </Box>
        </Box>
      </Dialog>
    </div>
  );
}
